import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from 'shell-models-lib';

@Metamodel.model({
    name: ModelConstants.udfLinkedService,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.UserDataFunctionsLabel),
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.UserDataFunctionsLabel)
    ]
})
export class FabricUserDataFunctionsLinkedService extends LinkedService { }
